/**
 * The platform's own name, as it appears on its marketing site.
 *
 * PLACEHOLDER. "PawBook" stands in until the real name is chosen; it is not
 * registered and must not ship to production. It lives here as one constant so
 * renaming is a single edit rather than a search across the marketing page.
 *
 * A sitter's own business name is a different thing entirely: that comes from
 * the tenant record and is what a client sees on the storefront.
 */
export const PLATFORM_NAME = 'PawBook';

/** Used in the closing line of the footer. */
export const PLATFORM_TAGLINE = 'Booking and business management for pet professionals.';
